module.exports = __webpack_public_path__ + "static/media/gpa_card_icon.d3ce6785.svg";